import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './UrenExport.css';

const UrenExport = () => {
  const nu = new Date();

  // Bepaal huidige week+jaar
  const getCurrentWeek = () => {
    const d = new Date(Date.UTC(nu.getFullYear(), nu.getMonth(), nu.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  };

  const [week, setWeek] = useState(getCurrentWeek());
  const [jaar, setJaar] = useState(nu.getFullYear());
  const [monteurs, setMonteurs] = useState([]);
  const [geselecteerd, setGeselecteerd] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [periode, setPeriode] = useState({ start: '', eind: '' });

  useEffect(() => {
    laadStats();
  }, [week, jaar]);

  const laadStats = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/uren/export-sap-preview?week=${week}&jaar=${jaar}`);
      const data = res.data;
      setMonteurs(data.monteurs || []);
      setPeriode({ start: data.start_datum, eind: data.eind_datum });

      // Auto-select monteurs met uren
      const metUren = (data.monteurs || []).filter(m => m.aantal_records > 0).map(m => m.id);
      setGeselecteerd(metUren);
    } catch (e) {
      console.error('Laad stats fout:', e);
    } finally {
      setLoading(false);
    }
  };

  const toggleMonteur = (id) => {
    setGeselecteerd(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const allesAanUit = () => {
    if (geselecteerd.length === monteurs.length) {
      setGeselecteerd([]);
    } else {
      setGeselecteerd(monteurs.map(m => m.id));
    }
  };

  const wijzigWeek = (delta) => {
    let nieuweWeek = week + delta;
    let nieuwJaar = jaar;
    if (nieuweWeek < 1) {
      nieuweWeek = 52;
      nieuwJaar -= 1;
    } else if (nieuweWeek > 52) {
      nieuweWeek = 1;
      nieuwJaar += 1;
    }
    setWeek(nieuweWeek);
    setJaar(nieuwJaar);
  };

  const dezeWeek = () => {
    setWeek(getCurrentWeek());
    setJaar(nu.getFullYear());
  };

  const downloadExcel = async () => {
    if (geselecteerd.length === 0) {
      alert('Selecteer minimaal 1 monteur');
      return;
    }
    setDownloading(true);
    try {
      const token = localStorage.getItem('token');
      const monteur_ids = geselecteerd.join(',');
      const url = `/api/uren/export-sap?week=${week}&jaar=${jaar}&monteur_ids=${monteur_ids}`;

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.message || 'Download mislukt');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `Uren_Export_W${week}_${jaar}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (e) {
      alert('Download mislukt: ' + e.message);
    } finally {
      setDownloading(false);
    }
  };

  const formatDatum = (yyyymmdd) => {
    if (!yyyymmdd) return '';
    const [y, m, d] = yyyymmdd.split('-');
    return `${d}-${m}`;
  };

  const totaalUren = geselecteerd.reduce((acc, id) => {
    const m = monteurs.find(x => x.id === id);
    return acc + (m?.totaal_uren || 0);
  }, 0);

  const [wdJaar, setWdJaar] = useState(new Date().getFullYear());
  const [wdKwartaal, setWdKwartaal] = useState(1);
  const [wdBezig, setWdBezig] = useState(false);
  const wachtdienstExport = async () => {
    setWdBezig(true);
    try {
      const r = await api.get('/wachtdienst-export', {
        params: { jaar: wdJaar, kwartaal: wdKwartaal },
        responseType: 'blob'
      });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = `wacht-waak-${wdJaar}-Q${wdKwartaal}.xlsx`;
      a.click(); URL.revokeObjectURL(url);
    } catch (e) {
      let msg = 'Export mislukt';
      if (e.response && e.response.data instanceof Blob) {
        try { msg = JSON.parse(await e.response.data.text()).message || msg; } catch {}
      }
      alert(msg);
    }
    setWdBezig(false);
  };
  return (
    <div className="uren-export-page">
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '10px 14px', marginBottom: 14,
                    background: '#fffbeb', border: '1px solid #f59e0b', borderRadius: 10 }}>
        <span style={{ fontWeight: 700, fontSize: 13, color: '#92400e' }}>🔴 Wachtdienst-verantwoording</span>
        <select value={wdJaar} onChange={e => setWdJaar(parseInt(e.target.value))}
          style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 }}>
          {Array.from({ length: 4 }, (_, i) => new Date().getFullYear() - 2 + i).map(j => <option key={j} value={j}>{j}</option>)}
        </select>
        <select value={wdKwartaal} onChange={e => setWdKwartaal(parseInt(e.target.value))}
          style={{ padding: '6px 8px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 13 }}>
          {[1, 2, 3, 4].map(q => <option key={q} value={q}>Q{q}</option>)}
        </select>
        <button onClick={wachtdienstExport} disabled={wdBezig}
          style={{ padding: '7px 14px', background: '#f59e0b', color: 'white', border: 'none',
                   borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
          {wdBezig ? '…' : '📥 Export wachtdienst'}
        </button>
      </div>
      <div className="uren-export-card">

        <div className="uren-export-header">
          <h1>📊 Uren Export</h1>
          <span className="uren-export-format">SAP formaat</span>
        </div>

        <div className="uren-export-controls">
          <div className="uren-export-control-group">
            <label>Week</label>
            <select value={week} onChange={e => setWeek(parseInt(e.target.value, 10))}>
              {Array.from({ length: 52 }, (_, i) => i + 1).map(w => (
                <option key={w} value={w}>{w}</option>
              ))}
            </select>

            <label>Jaar</label>
            <select value={jaar} onChange={e => setJaar(parseInt(e.target.value, 10))}>
              {[2024, 2025, 2026, 2027, 2028].map(j => (
                <option key={j} value={j}>{j}</option>
              ))}
            </select>

            {periode.start && (
              <span className="uren-export-periode">
                {formatDatum(periode.start)} t/m {formatDatum(periode.eind)}
              </span>
            )}
          </div>

          <div className="uren-export-quick">
            <button onClick={() => wijzigWeek(-1)}>← Vorige</button>
            <button onClick={dezeWeek}>Deze week</button>
            <button onClick={() => wijzigWeek(1)}>Volgende →</button>
          </div>
        </div>

        <div className="uren-export-section-title">
          <span>Monteurs</span>
          <button className="uren-export-toggle" onClick={allesAanUit}>
            {geselecteerd.length === monteurs.length ? 'Niets aan' : 'Alles aan'}
          </button>
        </div>

        {loading ? (
          <div className="uren-export-loading">Laden...</div>
        ) : (
          <div className="uren-export-monteurs">
            {monteurs.length === 0 && (
              <div className="uren-export-empty">Geen monteurs gevonden</div>
            )}
            {monteurs.map(m => {
              const checked = geselecteerd.includes(m.id);
              const heeftUren = m.aantal_records > 0;
              return (
                <label
                  key={m.id}
                  className={`uren-export-monteur ${heeftUren ? '' : 'leeg'}`}
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => toggleMonteur(m.id)}
                  />
                  <span className="uren-export-naam">{m.naam}</span>
                  {heeftUren ? (
                    <>
                      <span className="uren-export-badge">
                        {m.totaal_uren.toFixed(2)} uren
                      </span>
                      <span className="uren-export-orders">
                        {m.aantal_orders} {m.aantal_orders === 1 ? 'order' : 'orders'}
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="uren-export-badge leeg">—</span>
                      <span className="uren-export-orders">geen uren</span>
                    </>
                  )}
                </label>
              );
            })}
          </div>
        )}

        <div className="uren-export-totaal">
          <span>{geselecteerd.length} {geselecteerd.length === 1 ? 'monteur' : 'monteurs'} geselecteerd</span>
          <span><strong>Totaal: {totaalUren.toFixed(2)} uren</strong></span>
        </div>

        <button
          className="uren-export-download-btn"
          onClick={downloadExcel}
          disabled={downloading || geselecteerd.length === 0}
        >
          {downloading ? 'Bezig met genereren...' : '📥 Download Excel'}
        </button>

      </div>
    </div>
  );
};

export default UrenExport;
